import { render, staticRenderFns } from "./scroll-to-top.vue?vue&type=template&id=55f6fa41"
import script from "./scroll-to-top.vue?vue&type=script&lang=js"
export * from "./scroll-to-top.vue?vue&type=script&lang=js"
import style0 from "./scroll-to-top.vue?vue&type=style&index=0&id=55f6fa41&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_nd5b4b5ys5eo7bulp7f5cn4bfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports